import validatePasswords from '@/helpers/validatePasswords'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    return validatePasswords()
  }
}
